import { render, staticRenderFns } from "./ItsRegistAgency.vue?vue&type=template&id=2f54170d&scoped=true&"
import script from "./ItsRegistAgency.vue?vue&type=script&lang=js&"
export * from "./ItsRegistAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54170d",
  null
  
)

export default component.exports